export const COVID_MESSAGE_SHOWN = "covidMessageShown";
export const CUSTOMER_VERIFICATION_DIALOG_ID = "customer-verification";
export const CACHE_STORE_KEY = "mat.ui.covid-message";
export const CONTENT_KEYS = {
	temporarySelfExclusionTermsLink: "self-exclusion.temporary-terms",
	permanentSelfExclusionTermsLink: "self-exclusion.permanent-terms",
	selfExclusionTermsAccept: "self-exclusion.terms.accept",
};
